import MobileDetect from "mobile-detect";

// Actions
export const CLIENT_SET_DEVICE_TYPE = "client/SET_DEVICE_TYPE";

// Reducer
const initialState = {
  phone: null,
  basePath: ""
};

export default function reducer(state = initialState, action = {}) {
  if (action.type === CLIENT_SET_DEVICE_TYPE) {
    const md = new MobileDetect(action.payload);
    return {
      ...state,
      phone: md.phone()
    };
  }
  return state;
}

// Action Creators
export const setDeviceType = payload => ({
  type: CLIENT_SET_DEVICE_TYPE,
  payload
});

// Selectors
export const isPhone = state => !!state.client.phone;
